/*
 * Action types
 */

// eslint-disable-next-line import/prefer-default-export
export const SET_LOCALE = 'SET_LOCALE';
